import React from 'react';
import { motion } from 'framer-motion';
import { QuoteIcon } from 'lucide-react';
interface MiniTestimonialProps {
  quote: string;
  name: string;
  age: number;
}
export function MiniTestimonial({
  quote,
  name,
  age
}: MiniTestimonialProps) {
  // Build initials from name
  const initials = name.charAt(0).toUpperCase();
  return <section className="relative w-full bg-black py-8 md:py-10 overflow-hidden" data-id="element-256">
      {/* Soft red glow */}
      <div className="absolute inset-0 z-0" data-id="element-257">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[300px] rounded-full bg-red-900/10 blur-[100px]" data-id="element-258" />
      </div>

      <div className="relative z-10 max-w-2xl mx-auto px-6" data-id="element-259">
        <motion.div initial={{
        opacity: 0,
        y: 15
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="relative bg-[#0a0a0a]/80 backdrop-blur-sm border border-red-900/40 rounded-xl p-6 md:p-8 shadow-[0_0_30px_rgba(220,38,38,0.08)] hover:border-red-600/50 hover:shadow-[0_0_40px_rgba(220,38,38,0.15)] transition-all duration-500" data-id="element-260">
          {/* Quote icon */}
          <div className="absolute -top-3 left-6 bg-black border border-red-900/60 rounded-lg p-2 shadow-[0_0_15px_rgba(220,38,38,0.2)]" data-id="element-261">
            <QuoteIcon className="w-4 h-4 text-red-500" fill="currentColor" data-id="element-262" />
          </div>

          <p className="text-base md:text-lg text-gray-200 leading-relaxed italic mb-5" data-id="element-263">
            "{quote}"
          </p>

          <div className="flex items-center gap-3 pt-4 border-t border-red-900/20" data-id="element-264">
            <div className="w-10 h-10 rounded-full bg-gradient-to-br from-red-700 to-red-900 border border-red-500/40 flex items-center justify-center text-white font-bold text-base shadow-[0_0_15px_rgba(220,38,38,0.3)]" data-id="element-265">
              {initials}
            </div>
            <div data-id="element-266">
              <p className="text-white font-semibold text-sm md:text-base" data-id="element-267">
                {name}, {age} años
              </p>
              <p className="text-red-500/70 text-xs uppercase tracking-widest" data-id="element-268">
                ★ ★ ★ ★ ★{' '}
                <span className="text-gray-500 ml-1" data-id="element-269">Cliente verificado</span>
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}